import { Box } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const RelativeBox = styled(Box)(({ theme }) => ({
  position: "relative",
}));

export default RelativeBox;
